import { Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { SearchBar } from "./";

const Navbar = () => (
  <Stack 
  direction="row" 
  alignItems="center" 
  p={2} 
  sx={{ position:  "sticky", backgroundColor: 'transparent' ,backdropFilter:"blur(20px)", top: 0, justifyContent: "space-between" }}>
    <Link to="/" style={{ display: "flex", alignItems: "center" }}>
      <img src={require("./logo.png")} alt="logo" height={45} />
    </Link>
    <SearchBar />
  </Stack>
);

export default Navbar;
